<template>
  <div class="theme-switch-wrapper m15">
    <label class="theme-switch" for="checkbox">
      <input @change="switchTheme($event)" type="checkbox" id="checkbox" />
      <div class="slider round"></div>
    </label>
    <em>Enable Dark Mode!</em>
  </div>
</template>


<script>
export default {
  name: "ThemeSwitcher",
  data: function () {
    return {
      userPref:
        window.matchMedia &&
        window.matchMedia("(prefers-color-scheme: dark)").matches
          ? "dark"
          : "light",
    };
  },
  mounted() {
    const toggleSwitch = document.querySelector(
      '.theme-switch input[type="checkbox"]'
    );
    const currentTheme = localStorage.getItem("theme");

    if (currentTheme) {
      document.documentElement.setAttribute("data-theme", currentTheme);

      if (currentTheme === "dark") {
        toggleSwitch.checked = true;
      }
    } else if (this.userPref) {
      document.documentElement.setAttribute("data-theme", this.userPref);

      if (this.userPref === "dark") {
        toggleSwitch.checked = true;
      }
    }
  },
  methods: {
    switchTheme(e) {
      if (e.target.checked) {
        document.documentElement.setAttribute("data-theme", "dark");
        localStorage.setItem("theme", "dark");
      } else {
        document.documentElement.setAttribute("data-theme", "light");
        localStorage.setItem("theme", "light");
      }
    },
  },
};
</script>
<style scoped>

/*slider switch css */
.theme-switch-wrapper {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
}

em {
  margin-left: 10px;
  font-size: 1rem;
}

.theme-switch {
  display: inline-block;
  height: 34px;
  position: relative;
  width: 60px;
}

.theme-switch input {
  display: none;
}

.slider {
  background-color: #ccc;
  bottom: 0;
  cursor: pointer;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  transition: 0.4s;
}

.slider:before {
  background-color: #fff;
  bottom: 4px;
  content: "";
  height: 26px;
  left: 4px;
  position: absolute;
  transition: 0.4s;
  width: 26px;
}

input:checked + .slider {
  background-color: #66bb6a;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>